import { Action } from 'redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { isAdminProfileUsersSpace } from '~src/spacesPlatform/state/SpaceInfo';

import { SelectedSystemUser } from './AdminProfileRemoveFromUserAction';

export const ADMIN_PROFILE_SITE_MEMBERSHIP = 'ADMIN_PROFILE_SITE_MEMBERSHIP';

export interface AdminProfileSiteMembershipActionPayload extends Action {
  type: typeof ADMIN_PROFILE_SITE_MEMBERSHIP;
  profileId: string;
  users: SelectedSystemUser[];
}

export function adminProfileSiteMembership(profileId: string, users: SelectedSystemUser[]): AdminProfileSiteMembershipActionPayload {
  return {
    type: ADMIN_PROFILE_SITE_MEMBERSHIP,
    profileId,
    users,
  };
}

/**
 * Opens dialog/modal for managing site membership for selected users. Only visible in Admin Profile Users tab.
 */
export const AdminProfileSiteMembershipAction: IEntityAction<IContentInfo<'serveruser'>, {}> = {
  name: EntityActionNames.AdminProfileSiteMembership,
  translateName: Messages.adminProfileAssignAdminProfileToUser,
  isVisible: (_targetItems: IContentInfo<'serveruser'>[], state: AppState) => {
    return isAdminProfileUsersSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo<'serveruser'>[]) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: IContentInfo<'serveruser'>[]) => {
    const state = getAppStore().getState();
    const spaceInfo = selectSpaceInfo(state);
    const profileId = spaceInfo?.item?.id ?? '';
    const users: SelectedSystemUser[] = targetItems.map(item => {
      const luids: string[] = (item as any).luids ?? [item.luid];
      const siteNames: string[] = (item as any).siteNames ?? [];
      return {
        luid: item.luid,
        id: item.id,
        systemUserId: (item as any).systemUserId,
        name: item.name,
        username: (item as any).username ?? '',
        siteInfos: luids.map((luid, i) => ({ luid, siteName: siteNames[i] ?? '' })),
      };
    });
    return adminProfileSiteMembership(profileId, users);
  },
};
